export default __webpack_public_path__ + "static/media/devops.8a33b27b.svg";